// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Weekday from "../../../../to-be-migrated/domain/types/common/Weekday.bs.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as DateTime$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as ListUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as AllocationDashboardUtils from "../../components/utils/AllocationDashboardUtils.bs.js";
import * as AllocationDashboardContent from "../../../../pricing-dashboard/view/components/vm-mapper/AllocationDashboardContent.bs.js";

function getRepeatDaysString(days) {
  if (days !== undefined && List.length(days) !== 7) {
    return ListUtils$Catalyst.toString(Belt_List.map(days, (function (x) {
                      return Weekday.toString(Weekday.fromString(x));
                    })), (function (a) {
                  return $$String.sub(a, 0, 3);
                }), undefined, undefined);
  } else {
    return "All";
  }
}

function mapZonesToId(zones, zone_ids) {
  return List.map((function (z) {
                return z.description;
              }), List.filter(function (z) {
                    return List.exists((function (i) {
                                  return i === z.id;
                                }), zone_ids);
                  })(zones));
}

function mapClustersToId(clusters, cluster_ids) {
  return List.map((function (c) {
                return c.description;
              }), List.filter(function (c) {
                    return List.exists((function (i) {
                                  return i === c.id;
                                }), cluster_ids);
                  })(clusters));
}

function serializeZoneAndClusterData(descriptions) {
  if (!descriptions) {
    return {
            content: "Not Applicable",
            tool_tip_content: undefined
          };
  }
  var match = descriptions.tl;
  var a = descriptions.hd;
  if (!match) {
    return {
            content: a,
            tool_tip_content: undefined
          };
  }
  var tail = match.tl;
  var b = match.hd;
  if (tail) {
    return {
            content: a + (", " + (b + ", ")),
            tool_tip_content: {
              content: ListUtils$Catalyst.toString(tail, (function (a) {
                      return a;
                    }), undefined, undefined),
              title: "+" + (String(List.length(tail)) + " more")
            }
          };
  } else {
    return {
            content: a + (", " + b),
            tool_tip_content: undefined
          };
  }
}

function getViewModel(campaign, zones, clusters) {
  var v = campaign.clusters;
  var tmp;
  if (v !== undefined) {
    var match = Belt_List.length(v);
    tmp = match !== 0 ? "Cluster" : "Zone";
  } else {
    tmp = "Zone";
  }
  var z = campaign.zones;
  var c = campaign.clusters;
  var v$1 = campaign.startDate;
  var v$2 = campaign.startTime;
  var v$3 = campaign.endDate;
  var v$4 = campaign.endTime;
  var v$5 = campaign.subType;
  var tmp$1;
  if (v$5 !== undefined) {
    switch (v$5) {
      case /* AllocationRadius */0 :
          tmp$1 = "Allocation Radius";
          break;
      case /* DryRun */1 :
          tmp$1 = "Dry Run Ratio";
          break;
      case /* MaxDryRun */2 :
          tmp$1 = "Max Dry Run";
          break;
      
    }
  } else {
    tmp$1 = "Not Applicable";
  }
  var v$6 = campaign.subType;
  var tmp$2;
  if (v$6 !== undefined) {
    switch (v$6) {
      case /* AllocationRadius */0 :
          tmp$2 = AllocationDashboardContent.allocation_radius_info_icon;
          break;
      case /* DryRun */1 :
          tmp$2 = AllocationDashboardContent.dry_run_info_icon;
          break;
      case /* MaxDryRun */2 :
          tmp$2 = AllocationDashboardContent.max_dry_run_info_icon;
          break;
      
    }
  } else {
    tmp$2 = "Not Applicable";
  }
  var match$1 = Belt_Option.getExn(campaign.subType);
  var tmp$3;
  switch (match$1) {
    case /* AllocationRadius */0 :
        tmp$3 = {
          left_value: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getFilterValueOrDefault(campaign.allocationRadiusAutomatic),
          right_value: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getFilterValueOrDefault(campaign.allocationRadiusManual),
          radius_delta: campaign.allocationRadiusDelta
        };
        break;
    case /* DryRun */1 :
        tmp$3 = {
          left_value: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getFilterValueOrDefault(campaign.thresholdDistance),
          right_value: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getFilterValueOrDefault(campaign.dryRunRatio),
          radius_delta: campaign.dryRunDelta
        };
        break;
    case /* MaxDryRun */2 :
        tmp$3 = {
          left_value: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getFilterValueOrDefault(campaign.maxDryRunAutomatic),
          right_value: AllocationDashboardUtils.CreateZonalOrClusterCampaigns.getFilterValueOrDefault(campaign.maxDryRunManual),
          radius_delta: campaign.maxDryRunDelta
        };
        break;
    
  }
  return {
          vehicle: campaign.vehicle,
          geo_region: campaign.geo_region,
          created_by: campaign.created_by,
          created_on: Timestamp$Catalyst.toString(campaign.created_on, "DD-MMM-YYYY"),
          _type: tmp,
          zones: z !== undefined ? serializeZoneAndClusterData(mapZonesToId(zones, z)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              }),
          has_cluster: campaign.hasCluster,
          clusters: c !== undefined ? serializeZoneAndClusterData(mapClustersToId(clusters, c)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              }),
          campaignName: campaign.campaignName,
          startDate: v$1 !== undefined ? DateTime$Catalyst.format(Caml_option.valFromOption(v$1), "DD-MMM-YYYY") : "Not Applicable",
          startTime: v$2 !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(v$2), "HH:mm") : "Not Applicable",
          endDate: v$3 !== undefined ? DateTime$Catalyst.format(Caml_option.valFromOption(v$3), "DD-MMM-YYYY") : "Not Applicable",
          endTime: v$4 !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(v$4), "HH:mm") : "Not Applicable",
          days: getRepeatDaysString(campaign.days),
          subType: tmp$1,
          infoIconDescription: tmp$2,
          filter: tmp$3
        };
}

var VMMapper = {
  getViewModel: getViewModel
};

export {
  getRepeatDaysString ,
  mapZonesToId ,
  mapClustersToId ,
  serializeZoneAndClusterData ,
  VMMapper ,
  
}
/* DateTime-Catalyst Not a pure module */
